/**
 * localStorage with error handling for when the `localStorage` is disabled on the device.
 * @see https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document/
 */
export const LocalStorage = {
  getItem(key: string, fallbackValue: string | null = null): string | null {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn(`Failed to get item from localStorage:`, e);
      return fallbackValue;
    }
  },

  setItem(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      console.warn(`Failed to set item in localStorage:`, e);
      return false;
    }
  },

  removeItem(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      console.warn(`Failed to remove item from localStorage:`, e);
      return false;
    }
  },
};
